import { render, staticRenderFns } from "./PaymentCollapse.vue?vue&type=template&id=5b79e89c&scoped=true"
import script from "./PaymentCollapse.vue?vue&type=script&lang=js"
export * from "./PaymentCollapse.vue?vue&type=script&lang=js"
import style0 from "./PaymentCollapse.vue?vue&type=style&index=0&id=5b79e89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79e89c",
  null
  
)

export default component.exports